import Script from 'next/script'
import { memo } from 'react'

declare global {
  interface Window {
    gtag: (...args: any[]) => void
  }
}

export default memo(function GoogleAnalytics({ measurementId }: { measurementId: string | undefined }) {
  if (!measurementId) return null
  return (
    <>
      <Script strategy="afterInteractive" src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`} />
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${measurementId}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
      <Script id="google-analytics" strategy="afterInteractive">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${measurementId}');
        `}
      </Script>
    </>
  )
})
export const trackCustomEvent = (event: string, payload: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', event, payload)
  }
}
